export function splitRiotId(riotId: string, delimiter = "#") {
  let [inputRiotUserName, inputRiotTagLine = ""] = (riotId || "").split(delimiter || "#");
  inputRiotUserName = inputRiotUserName.trim();

  return [inputRiotUserName, inputRiotTagLine];
}
